
import React, {Component} from 'react';
import axios from 'axios';
import {  withRouter } from "react-router-dom";
//import GoogleMapReact from 'google-map-react';
//import ReactImageMagnify from 'react-image-magnify';
//import { Alert } from 'reactstrap';
import auth0Client from '../Auth';
import {ToastContainer, ToastStore} from 'react-toasts';
import Toggle from "react-toggle-component"
import "react-toggle-component/styles.css"
import {LOCAL_URL} from '../Constants'
import DatePicker from "react-datepicker";
import {SERVER_URL}  from '../Constants';
import ReactImageMagnify from 'react-image-magnify';

class SRItem extends Component {
    constructor(props) {
      super(props);
      
      //const srItem = this.props.SRItem;
      
      this.state = {
        venueid:-1,
        srItem: undefined,
        id: -1,
        recipient: '',
        labelText: '',
        guestPickupDate: new Date(),
        dateReceived: new Date(),
        picUrl:'../default-placeholder.png',
        signUrl:undefined,
        venueId: '',
        createdAt: new Date(),
        barcodeValue:'',
        storageLocation:'',
        parcelGroupTotalCount:0,
        parcelGroupNum:0,
        parcelRef:'',
        statusCd:'I',
        serviceFee:0.00,
        roomNumber:'',
        reservationId:'',
        arrivalDate:undefined,
        dateDelivered:undefined,
        defaultParcelFees:[],
        parcelSize:'',
        note:'',
        departureDate:undefined,
        groupName:'',
        booth:'',
        isPaid:false,
        paidAt:undefined,
        paidAmount:0.00,
      }
    }

    getParcelSizeAndFeeList = async(venue)=>{
      try {
        //let defaultFeesList = [];
        //if (venue.parcelFeeDefaults){
        //  defaultFeesList = (venue.parcelFeeDefaults && venue.parcelFeeDefaults!=='') ? JSON.parse(venue.parcelFeeDefaults).parcelFeeDefaults : [];
       // }
      let res = await axios.get(`${SERVER_URL}/venue/parcelfeedefaults`,{headers: { 'Authorization': `Bearer ${auth0Client.getIdToken()}`, 'venueid':auth0Client.getActiveVenuedId() }});
       
          //console.log(res.data);
          return (res.data && res.data.parcelFeeDefaults) ? res.data.parcelFeeDefaults :[]
      }catch(e){
        console.log(e.message);
        return [];
      }
    }
    async componentDidMount() {
        const { match: { params } } = this.props;
    
        //console.log(params.lostItemId);
    
        //console.log(auth0Client.getDefaultVenue().venueTypeCd);
        
        const venue = auth0Client.getDefaultVenue();
        let defaultFeesList = await this.getParcelSizeAndFeeList(venue);
       

        this.setState({
          venueTypeCd:venue.venueTypeCd,
          defaultParcelFees:defaultFeesList
        })     
    
        if (params.id==='-1'){
          return;
        }

        // Load the SRITem from the server
        const srItem = (await axios.get(`${SERVER_URL}/SR/${params.id}`, {headers: { 'Authorization': `Bearer ${auth0Client.getIdToken()}` }})).data;
        //console.log(srItem);
        if (srItem===undefined){
            return;
        }


        this.setState({
            id : srItem.id,
            srItem:srItem,
            picUrl: (srItem.picUrl==='') ? '../default-placeholder.png' : srItem.picUrl, 
            signUrl: (srItem.signUrl==='') ? undefined : srItem.signUrl,
            recipient: srItem.recipient,
            labelText: srItem.labelText,
            guestPickupDate: (srItem.guestPickupDate) ? new Date(srItem.guestPickupDate) : undefined,
            dateReceived: (srItem.dateReceived) ? new Date(srItem.dateReceived) : undefined,
            venueId: srItem.venueId,
            createdAt: new Date(srItem.createdAt) ,
            barcodeValue: srItem.barcodeValue,
            storageLocation: srItem.storageLocation,
            parcelGroupTotalCount: srItem.parcelGroupTotalCount,
            parcelGroupNum: srItem.parcelGroupNum,
            parcelRef:srItem.parcelRef,
            statusCd:srItem.statusCd,
            serviceFee:srItem.serviceFee,
            roomNumber:srItem.roomNumber,
            reservationId:srItem.reservationId,
            arrivalDate:(srItem.arrivalDate) ? new Date(srItem.arrivalDate) : undefined,
            dateDelivered:(srItem.dateDelivered) ? new Date(srItem.dateDelivered) : undefined,
            parcelSize:srItem.parcelSize,
            note:srItem.note,
            departureDate: (srItem.departureDate) ? new Date(srItem.departureDate) : undefined,
            groupName:srItem.groupName,
            booth:srItem.booth,
            isPaid:srItem.isPaid,
            paidAt:(srItem.paidAt) ? new Date(srItem.paidAt) : undefined,
            paidAmount:srItem.paidAmount,
            deliveredBy:srItem.deliveredBy,
        })
        // set the  state

    }
    handleInputChange=(event) =>{
        const target = event.target;
        const value = target.type === 'checkbox' ? target.checked : target.value;
        const name = target.name;
    
        this.setState({
          [name]: value
        });
      }
      handleStatusInputChange=(event) =>{
        const target = event.target;
        const value =  target.value;
        let dateDelivered = this.state.dateDelivered;
        if (value!=='D'){
          dateDelivered =undefined
        }
        const name = target.name;
    
        this.setState({
          [name]: value,
          dateDelivered: dateDelivered
        });
      }


      onDateReceivedChange = date => this.setState({ dateReceived:date });
      onGuestPickupDateChange= date => this.setState({ guestPickupDate:date });
      onArrivalDate= date => this.setState({ arrivalDate:date });
      onDateDeliveredChange= date => this.setState({ dateDelivered:date });
      onDepartureDate= date => this.setState({ departureDate:date });
  
  handleSizeChange=(e)=>{
    let fee= 0.00;
    let size = e.target.value;
    
    try{
      for(var i=0; i<this.state.defaultParcelFees.length; i++){
        if (this.state.defaultParcelFees[i].size===size){
          fee =  parseFloat(this.state.defaultParcelFees[i].fee);

        }
      }
      this.setState({
        serviceFee:fee,
        parcelSize:size
      })
    }catch(e){
      this.setState({
        serviceFee:0.00,
        size:''
      })
    }
    
    
  }

  validate=async()=>{

    // check the short Description
    if (!this.state.recipient) {alert('invalid or missing recipient'); return false;}
     
    return true;


  }
  
  renderGoBack =()=>{
    return (
      <button className="btn btn-outline-secondary" onClick={() => this.props.history.goBack()}><h5> BACK </h5></button>
    )
  }

  

  renderToast=()=>{
    return <div>
        
        <ToastContainer position={ToastContainer.POSITION.TOP_RIGHT} lightBackground store={ToastStore}/>
    </div>
  }

 addToLostAndFound=async()=>{
    if (!this.state.recipient) {alert('invalid or missing recipient'); return ;}
    if (this.state.id==='') {alert('invalid or missing id.  Save the record first, then try again'); return ;}

    if (!window.confirm("Your about to add this parcel to the lost & found. Press OK to continue")) { return;}
    this.setState({
      disabled: true,
    }); 
      await axios.post(`${SERVER_URL}/SR/addToLostAndFound`, {
            id:this.state.id
      }, {
        headers: { 
          'Authorization': `Bearer ${auth0Client.getIdToken()}`,
          'venueId': auth0Client.getActiveVenuedId()
        }
      })
      .then((res)=>{
          //this.props.history.push('/');
          // Show saved successful
          if(res.status!==200){
            // console.log(JSON.stringify(res));
             ToastStore.error("An error occured: " + res.response.statusText);
           }else{
             ToastStore.success('Added Successfully!');
             
           }
  
  
          this.setState({
            showAlert:false,
            disabled: false,
            showSuccess: true,
           
  
        })
        //ToastStore.success('Lost Item Saved Successfully!');
      })
      .catch ((e)=>{
          
          this.setState({
              showAlert:true,
              disabled: false,
              error:e,
  
          })
          ToastStore.error(e.message);
      });
  
  
    
  }



      submit=async()=>{

        if (!this.validate()){
          return;
        }
    
        this.setState({
          disabled: true,
        });
    
        await axios.put(`${SERVER_URL}/SR/`, {
            id:this.state.id,
            recipient: this.state.recipient,
            labelText: this.state.labelText,
            dateReceived: (this.state.dateReceived) ? new Date(this.state.dateReceived) : new Date(),
            guestPickupDate: (this.state.guestPickupDate) ? new Date(this.state.guestPickupDate) : undefined,
            venueId: this.state.venueId,
            barcodeValue: this.state.barcodeValue,
            storageLocation: this.state.storageLocation,
            // skip sending the images down
            parcelGroupTotalCount: this.state.parcelGroupTotalCount,
            parcelGroupNum: this.state.parcelGroupNum,
            parcelRef:this.state.parcelRef,
            statusCd:this.state.statusCd,
            serviceFee:this.state.serviceFee,   
            roomNumber:this.state.roomNumber,
            reservationId:this.state.reservationId,
            arrivalDate:this.state.arrivalDate,
            parcelSize:this.state.parcelSize,
            dateDelivered:this.state.dateDelivered,
            note:this.state.note,
            departureDate: this.state.departureDate,
            groupName:this.state.groupName,
            booth:this.state.booth,
            isPaid:this.state.isPaid,
            paidAt:this.state.paidAt,
            paidAmount:this.state.paidAmount,
            deliveredBy:this.state.deliveredBy,
            
        }, {
          headers: { 
            'Authorization': `Bearer ${auth0Client.getIdToken()}`,
            'venueId': auth0Client.getActiveVenuedId()
          }
        })
        .then((res)=>{
            //this.props.history.push('/');
            // Show saved successful
            if(res.status!==200){
              // console.log(JSON.stringify(res));
               ToastStore.error("An error occured: " + res.response.statusText);
             }else{
               ToastStore.success('Saved Successfully!');
               
             }
    
    
            this.setState({
              showAlert:false,
              disabled: false,
              showSuccess: true,
             
    
          })
          //ToastStore.success('Lost Item Saved Successfully!');
        })
        .catch ((e)=>{
            
            this.setState({
                showAlert:true,
                disabled: false,
                error:e,
    
            })
            ToastStore.error(e.message);
        })
    
    
      }
    
    
    renderSignature =()=>{
      
      if (this.state.signUrl===undefined){
      
        return(
          <h5> No Signature</h5>
        )}else{
        
          return (
            <div style={{border:'1px solid gray', textAlign:'center'}}>
              <br/>
            <img style={{maxWidth:150, width:"150",maxHeight:150, height:"150", alignContent:'center'}} src={this.state.signUrl} alt=' '/> 
            </div>
          )
        }
      }
    
    
    
      createReturnReceipt=()=>{
          // Send to the printer. 
         

            var params = this.state.id + '&tid=' + auth0Client.getIdToken() + '&vid=' + auth0Client.getActiveVenuedId();
            
            window.open(`${LOCAL_URL}/SRItem/PrintReceipt/` + params, '_blank', 'menubar=1,toolbar=1');
          
       

      };

    renderPaymentArea=()=>{
      return (
        <div >
            <div className='row'>
              <div className='col' >
               
                  <label htmlFor="serviceFee" className='text-primary'><h5>Payment Status:</h5></label>
              </div>
            </div>
          <div className='row'>
              <div className='col text-center' style={{verticalAlign:'middle'}}>
              <br/>
                  <Toggle id='isPaid' labelRight="Paid" checked={this.state.isPaid} onToggle={value => this.setState({
                    isPaid:value}, ()=>{
                      if (!value){
                        this.setState({
                          paidAmount:0.00,
                          paidAt:undefined
                        })
                      } else{
                        this.setState({
                          paidAmount:this.state.serviceFee,
                          paidAt:new Date()
                        })
                      }
                    })} /> 
              </div>
          <div className='col'>
          <label htmlFor="paidAmount" className='text-primary'><b>Amount Paid:</b></label>
          <input
              disabled={this.state.disabled}
              type="number"
              onChange={this.handleInputChange}
              name="paidAmount"
              className="form-control"
              placeholder=""
              value= {this.state.paidAmount}
          />
          </div>
          <div className='col'>
          <label htmlFor="paidAt" className='text-primary'><b>Date Paid:</b></label>
          <br/>
          <DatePicker
          autoComplete='off'
            className="form-control"
              onChange={this.onPaidAtChange}
              name="paidAt"
              selected={this.state.paidAt}
            /> 
          </div>
          </div>
        </div>
      );
    }
    
      render(){

        if (this.state.id===undefined){
          return (
          
              <div className="container text-center">
             
              <br/>
              <h3 className='text-info'>Loading ...</h3>
        
              </div>
               
            )
      }else{

      
        return(
            <div style={{margin:'5px'}}>
               
             
              {this.renderToast()}
              <div className="row">
                <div className='col text-left'>
                  {this.renderGoBack()}
                </div>
                <div className='col text-right'>
                  <h4>Parcel Received Editor  </h4>
                </div>
              </div>
       
                
                <br/>
                <div className="row">
                        
                          <div className='col-6' >
                           <h5 className="text-info">Parcel Details </h5>
                           <hr/>
                           <div className='row'>
                              <div className='col'>
                                <label htmlFor="recipient" className='text-danger'><b>Recipient (required):</b></label>
                                                <input
                                                    disabled={this.state.disabled}
                                                    type="text"
                                                    onChange={this.handleInputChange}
                                                    name="recipient"
                                                    className="form-control"
                                                    placeholder="Please provide recipient."
                                                    value= {this.state.recipient}
                                                />

                              </div>
                             {
                              
                              <div className='col'>
                                <label htmlFor="groupName" className='text-primary'><b>Group Name/Code:</b></label>
                                                <input
                                                    disabled={this.state.disabled}
                                                    type="text"
                                                    onChange={this.handleInputChange}
                                                    name="groupName"
                                                    className="form-control"
                                                    placeholder="Group name or code"
                                                    value= {this.state.groupName}
                                                />

                              </div>
                              
                              
                             } 
                            <div className='col'>
                                <label htmlFor="booth" className='text-primary'><b>Booth:</b></label>
                                                <input
                                                    disabled={this.state.disabled}
                                                    type="text"
                                                    onChange={this.handleInputChange}
                                                    name="booth"
                                                    className="form-control"
                                                    placeholder=""
                                                    value= {this.state.booth}
                                                />

                              </div>
                           </div>
                           <div className='row'>
                              <div className='col'>
                                <label htmlFor="labelText" className='text-primary'><b>Parcel Label Text:</b></label>
                                <textarea
                                            disabled={this.state.disabled}
                                            type="text"
                                            name="labelText"
                                            onChange={this.handleInputChange}
                                            className="form-control"
                                            placeholder="Please provide a description for the lost Item."
                                            value= {this.state.labelText}
                                            style = {{height:150, fontSize:10}}
                                          />
                                </div>
                           </div> 
                         
                           <div className='row'>
                              <div className='col'>
                                <label htmlFor="dateReceived" className='text-primary'><b>Date Parcel Received:</b></label>
                                              <br/>
                                              <DatePicker
                                               autoComplete='off'
                                                className="form-control"
                                                  onChange={this.onDateReceivedChange}
                                                  name="dateReceived"
                                                  selected={this.state.dateReceived}
                                                /> 
                                </div> 
                          

                              <div className='col'>
                              <label htmlFor="statusCd" className='text-primary'><b>Current Status:</b></label>
                                          
                                          <select className='custom-select'  value={this.state.statusCd} name='statusCd' onChange={this.handleStatusInputChange}>
                                            <option value="A">Archive</option>
                                            <option value="D">Guest: Delivered</option>
                                            <option value="GP">Guest: Pickup</option>
                                            <option value="I">In Storage</option>
                                            <option value="SB">Sent Back</option>
                                            
                                          </select>
                              </div>

                              <div className='col'>
                                <label htmlFor="dateDelivered" className='text-primary'><b>Guest Delivered Dt.:</b></label>
                                              <br/>
                                              <DatePicker
                                               autoComplete='off'
                                                className="form-control"
                                                  onChange={this.onDateDeliveredChange}
                                                  name="dateDelivered"
                                                  selected={this.state.dateDelivered}
                                                /> 
                                </div>
                                <div className='col'>
                                <label htmlFor="deliveredBy" className='text-primary'><b>Delivered By:</b></label>
                                <input
                                                    disabled={this.state.disabled}
                                                    type="text"
                                                    onChange={this.handleInputChange}
                                                    name="deliveredBy"
                                                    className="form-control"
                                                    placeholder=""
                                                    value= {this.state.deliveredBy}
                                                />
                                </div>
                            </div>

                            <br/>
                            <div className='row'>
                              <div className='col'>
                                <label htmlFor="barcodeValue" className='text-primary'><b>Tracking# / Barcode:</b></label>
                                <input
                                                    disabled={this.state.disabled}
                                                    type="text"
                                                    onChange={this.handleInputChange}
                                                    name="barcodeValue"
                                                    className="form-control"
                                                    placeholder="Please provide barcodeValue if available."
                                                    value= {this.state.barcodeValue}
                                                />
                                </div>
                                <div className='col'>
                                <label htmlFor="note" className='text-primary'><b>Notes:</b></label>
                                <textarea
                                                    disabled={this.state.disabled}
                                                    type="text"
                                                    onChange={this.handleInputChange}
                                                    name="note"
                                                    maxLength={150}
                                                    className="form-control"
                                                    
                                                    value= {this.state.note}
                                                />
                                </div>

                           </div> 
                           <br/>
                           <div className='row'>
                              <div className='col'>
                                <label htmlFor="storageLocation" className='text-primary'><b>Storage Location:</b></label>
                                <input
                                                    disabled={this.state.disabled}
                                                    type="text"
                                                    onChange={this.handleInputChange}
                                                    name="storageLocation"
                                                    className="form-control"
                                                    placeholder="i.e. Security Office or Front Desk"
                                                    value= {this.state.storageLocation}
                                                />
                                </div> 

                                <div className='col'>
                                <label htmlFor="parcelRef" className='text-primary'><b>Reference:</b></label>
                                <input
                                                    disabled={this.state.disabled}
                                                    type="text"
                                                    onChange={this.handleInputChange}
                                                    name="parcelRef"
                                                    className="form-control"
                                                    placeholder="Your internal reference codes"
                                                    value= {this.state.parcelRef}
                                                />
                                </div>

                        
                           </div>

                          <br/>
                           <div className='row'>
                                <div className='col'>
                                <label htmlFor="parcelRef" className='text-primary'><b>Parcel #:</b></label>
                                <input
                                                    disabled={this.state.disabled}
                                                    type="number"
                                                    onChange={this.handleInputChange}
                                                    name="parcelGroupNum"
                                                    className="form-control"
                                                    placeholder=""
                                                    value= {this.state.parcelGroupNum}
                                                />
                                </div>
                                
                                <div className='col'>
                                <label htmlFor="parcelRef" className='text-primary'><b> of Total:</b></label>
                                <input
                                                    disabled={this.state.disabled}
                                                    type="number"
                                                    onChange={this.handleInputChange}
                                                    name="parcelGroupTotalCount"
                                                    className="form-control"
                                                    placeholder=""
                                                    value= {this.state.parcelGroupTotalCount}
                                                />
                                </div>
                                
                                <div className='col'>
                              <label htmlFor="parcelSize" className='text-primary'><b>Parcel Size:</b></label>
                                        
                                          <select className='custom-select'  value={this.state.parcelSize} name='parcelSize' onChange={this.handleSizeChange}>
                                                  <option value="" fee={0.00}></option>
                                                    {
                                                      this.state.defaultParcelFees.map((item,index)=>{
                                                          return(
                                                            <option value={item.size} fee={item.fee}>{item.size}</option>
                                                          )
                                                      })
                                                    }
                                            
                                          </select>
                              </div>


                                <div className='col'>
                                <label htmlFor="parcelRef" className='text-primary'><b>Handling Fee:</b></label>
                                <input
                                                    disabled={this.state.disabled}
                                                    type="number"
                                                    
                                                    onChange={this.handleInputChange}
                                                    name="serviceFee"
                                                    className="form-control"
                                                    placeholder=""
                                                    value= {this.state.serviceFee}
                                                />
                                </div>


                          </div>
                          <br/>
                          <h5 className="text-info"> Guest Reservation Details </h5>
                           <hr/>
                          <div className='row'>
                                <div className='col'>
                                <label htmlFor="roomNumber" className='text-primary'><b>Room #:</b></label>
                                <input
                                                    disabled={this.state.disabled}
                                                    type="text"
                                                    onChange={this.handleInputChange}
                                                    name="roomNumber"
                                                    className="form-control"
                                                    placeholder=""
                                                    value= {this.state.roomNumber}
                                                />
                                </div>
                                <div className='col'>
                                <label htmlFor="reservationId" className='text-primary'><b>Reservation #:</b></label>
                                <input
                                                    disabled={this.state.disabled}
                                                    type="text"
                                                    onChange={this.handleInputChange}
                                                    name="reservationId"
                                                    className="form-control"
                                                    placeholder=""
                                                    value= {this.state.reservationId}
                                                />
                                </div>
                                <div className='col'>
                                <label htmlFor="arrivalDate" className='text-primary'><b>Arrival Date:</b></label>
                                              <br/>
                                              <DatePicker
                                               autoComplete='off'
                                                className="form-control"
                                                  onChange={this.onArrivalDate}
                                                  name="arrivalDate"
                                                  selected={this.state.arrivalDate}
                                                /> 
                                </div> 
                                <div className='col'>
                                <label htmlFor="departureDate" className='text-primary'><b>Departure Date:</b></label>
                                              <br/>
                                              <DatePicker
                                              autoComplete='off'
                                                className="form-control"
                                                  onChange={this.onDepartureDate}
                                                  name="departureDate"
                                                  selected={this.state.departureDate}
                                                /> 
                                </div> 
                            </div>
                           <br/>
                           <h5 className="text-info">Return Details</h5>
                           <hr/>
                          <br/>
                            <div className='row'>
                                <div className='col'>
                                        <label htmlFor="exampleInputEmail1" className='text-primary'><b>Pickup Date:</b></label>
                                                    <br/>
                                                    <DatePicker
                                                        className="form-control"
                                                        onChange={this.onGuestPickupDateChange}
                                                        name="guestPickupDate"
                                                        selected={this.state.guestPickupDate}
                                                        /> 
                                </div>
                                <div className='col'>
                                <label htmlFor="exampleInputEmail1" className='text-primary'><b>Signature:</b></label>
                                       {this.renderSignature()}
                                      
                                </div>

                             </div>  
                             <hr/>
                        <div className='row'>
                            <div className='col-3' >
                                <button
                                    disabled={this.state.disabled || auth0Client.ptReadOnly===true}
                                    className="btn btn-primary"
                                    onClick={() => {this.submit()}}>
                                    Update
                                    </button>
                                    </div>
                            <div className='col-5' >
                                <button
                                    disabled={this.state.disabled || auth0Client.ptReadOnly===true}
                                    className="btn btn-outline-info"
                                    onClick={() => {this.addToLostAndFound()}}>
                                    Add to Lost &amp; Found
                                    </button>
                            </div>
                            <div className='col-4' >
                                <button
                                    disabled={this.state.disabled}
                                    className="btn btn-outline-success"
                                    onClick={() => {this.createReturnReceipt()}}>
                                      Print Invoice
                                    </button>
                            </div>
                        </div>
                        

                          </div>
                          <div className='col-6' >
                          <h5> Parcel Image </h5>
                                    <hr/><br/>
                                <div className='row'>
                                <ReactImageMagnify enlargedImagePosition='over' {...{
                                        smallImage: {
                                            alt: this.state.recipient,
                                            isFluidWidth: true,
                                            src: this.state.picUrl,
                                            width: 400,
                                            height: 400,
                                        },
                                        largeImage: {
                                            src: this.state.picUrl,
                                            width: 1200,
                                            height: 1800
                                        }
                                    }} />
                                  
                                </div>   
                               <p>Mouse-over to magnify the image </p>
                           
                               <div className='row'>
                                <div className='col-8'>
                                    {this.renderPaymentArea()} 
                                    </div>
                              </div>        
                          </div>
                                

                </div>
               
            </div>


        )
      }
    }
}





export default withRouter(SRItem);